// import Base from './Base'
//
// import User from './user/User'
//
// import Order from './shop/Order'
// import Transaction from './shop/Transaction'
//
// import Product from './store/Product'
//
// import Image from './utils/media/image'
// import Countdown from './utils/timer/Countdown'
// import Paginator from './utils/paginator/Paginator'
import AutoCompletePlaces from './utils/autocomplete/Places'
//
// import Errors from './errors'

export const classes = {
  // Errors,
  // Base,
  // Shop: {
  //   Order,
  //   Transaction
  // },
  // User,
  // Store: {
    // Product
  // },
  Utils: {
    // Countdown,
    // Paginator,
    AutoCompletePlaces,
    // Media: {
    //   Image,
    // }
  }
}
export default classes

window.addiesaas.classes = classes
